import { Suspense, useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { I18nProvider } from '../_metronic/i18n/i18nProvider'
import { LayoutProvider, LayoutSplashScreen } from '../_metronic/layout/core'
import { MasterInit } from '../_metronic/layout/MasterInit'
import Gleap from 'gleap'

const App = () => {

  useEffect(() => {
    if (process.env.REACT_APP_ENV !== 'production') {
      if (process.env.REACT_APP_GLEAP_KEY) {
        Gleap.initialize(process.env.REACT_APP_GLEAP_KEY);
      } else {
        console.error('Gleap key is not defined');
      }
    }
  }, []);

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <I18nProvider>
        <LayoutProvider>
          <Outlet />
          <MasterInit />
        </LayoutProvider>
      </I18nProvider>
    </Suspense>
  )
}

export { App }
